// extracted by mini-css-extract-plugin
module.exports = {"container":"Welcome_container__2HLg1","title":"Welcome_title__35yox","description":"Welcome_description__25bvY","button":"Welcome_button__3wTCN"};